const incidentFindings = (() => {
  let findingTable, findingData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Findings
  //-------------------------------------------------------------------------------

  function getIncidentFindingView() {
    const frag = document.createDocumentFragment();
    
    findingTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Type'],
      endIcon: true,
    });

    const headers = findingTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addFindingBtnDiv = document.createElement('div');
    const addFindingBtn = new Button({
      text: 'ADD NEW FINDING',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(findingTable);
    if ($.session.SetupInsert) {
      addFindingBtn.button.style.float = 'right';
      addFindingBtn.renderTo(addFindingBtnDiv);
      frag.append(addFindingBtnDiv);
    }

    const tableFindingData = findingData
      .map(p => {
        return {
          values: [p.findingName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showFindingPopup(p);
          },
          endIconCallback: () => handleFindingDelete(p),
        };
      });

    table.populate(findingTable, tableFindingData);
    table.sortTableByHeader(findingTable);

    addFindingBtn.onClick(e => {
      showFindingPopup();
    });

    return frag;
  }

  // Incident Findings
  //-------------------------------------------------------------------------------

  function showFindingPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const findingForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Type',
          id: 'cName',
          required: true,
        },
      ],
    });

    findingForm.onKeyup(() => {
      findingForm.inputs['cName'].setValidtyError('');
      findingForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(findingForm);
    });
    findingForm.onChange(event => {
      findingForm.inputs['cName'].setValidtyError('');
      findingForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(findingForm);
    });

    findingForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentFindingData', {
          id: rowData ? rowData.findingId : 0,
          findingName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentFindingDataResult;
      const newID = resp.findingId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This finding already exists.', findingForm);
        findingForm.buttons['submit'].toggleDisabled(true);
        findingForm.buttons['cancel'].toggleDisabled(true);
      } else {
        findingForm.clear();
        POPUP.hide(popup);
        await getFindingData();
        updateFindingTable();
      }
    });

    findingForm.onCancel(event => {
      findingForm.clear();
      findingForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    findingForm.renderTo(popup);

    POPUP.show(popup);

    findingForm.populate({
      cName: rowData ? rowData.findingName : '',
    });

    findingForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      findingForm.disableFormInputs();
    }
  }

  async function handleFindingDelete(row) {
    const rowData = findingData.find(a => a.findingId == row.findingId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This finding type is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this finding type?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentFindingData', {
            token: $.session.Token,
            findingId: row.findingId,
          });

          await getFindingData();
          updateFindingTable();
        }
      });
    }
  }
  function updateFindingTable() {
    const tableFindingData = findingData
      .map(p => {
        return {
          values: [p.findingName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showFindingPopup(p);
          },
          endIconCallback: () => handleFindingDelete(p),
        };
      });

    table.populate(findingTable, tableFindingData);
  }

  async function getFindingData() {
    const dataFinding = await _UTIL.fetchData('getIncidentFinding');
    findingData = dataFinding.getIncidentFindingResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getFindingData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Findings';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Findings') {
      viewMarkup = getIncidentFindingView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
